/**
 * ChecklistSettingsTab - Aba "Checklist" das Configurações do tenant
 *
 * Liga/desliga o módulo (Template de Checklist + Vistorias). Somente
 * administradores; a validação real acontece na RPC.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-26 v1.0.0 - Criação inicial
 */
import { ClipboardList } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { SettingsCard, SettingsSectionHeader } from '@/components/tenant/SettingsInfoRow';
import { useChecklistModule } from '@/hooks/useChecklistModule';

export function ChecklistSettingsTab() {
  const { isEnabled, isLoading, toggleModule } = useChecklistModule();
  const navigate = useNavigate();

  if (isLoading) return <Skeleton className="h-40 w-full rounded-lg" />;

  return (
    <SettingsCard>
      <SettingsSectionHeader
        eyebrow="Módulo"
        title="Checklist"
        description="Habilita o Template de Checklist (em Configurações) e a aba Vistoria no cadastro de veículos."
      />
      <div className="flex items-center justify-between gap-4 px-6 py-4">
        <div className="flex items-start gap-3">
          <ClipboardList className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="space-y-1 text-sm">
            <p className="font-medium text-foreground">Habilitar módulo Checklist</p>
            <p className="text-muted-foreground">
              Desligar esconde as telas, mas nenhum modelo ou vistoria é apagado.
            </p>
          </div>
        </div>
        <Switch
          checked={isEnabled}
          disabled={toggleModule.isPending}
          onCheckedChange={(v) => toggleModule.mutate(v)}
          aria-label="Habilitar módulo Checklist"
        />
      </div>
      {isEnabled && (
        <div className="px-6 pb-4">
          <Button variant="outline" size="sm" onClick={() => navigate('/tenant/settings/checklist-templates')}>
            Abrir Template de Checklist
          </Button>
        </div>
      )}
    </SettingsCard>
  );
}
